import React, { useRef, useMemo, useState, useEffect, useContext } from 'react'
import JoditEditor from 'jodit-react';
import { Button } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2'
import { SchoolContex } from '../../Helper/Contex';

const AddBlogForm = (props) => {
// console.log("aaaa", props.modalData);
    const { schools } = useContext(SchoolContex)
    const [test, setTest] = useState(0);

    const [data, setData] = useState({
        // id: '',
        title: '',
        date: '',
        author: '',
        school: '',
        metaTitle: '',
        keywords: '',
        metaDesc: ''
    })
    const [cover, setCover] = useState();
    const [thumb, setThumb] = useState();
    const [details, setDetails] = useState();
    const [load, setLoad] = useState(false);

    const handleInput = (e) => {
        setData({
            ...data, [e.target.name]: e.target.value
        })
    }

    const handleImg = (e) => {
        if (e.target.name === 'thumb') {
            setThumb(e.target.files[0])

        }
        if (e.target.name === 'cover') {
            setCover(e.target.files[0]);

        }
    }

    const handleDetails = (e) => {
        setDetails(e)
    }

    // jodit editor
    const editor = useRef(null);

    const config = {
        uploader: {
            insertImageAsBase64URI: true
        },
        height: 320,
        triggerChangeEvent: true,
        readonly: false,
    }

    const Details = () => {
        return useMemo(() => (
            <JoditEditor
                // ref={editor}
                config={config}
                value={details}
                onChange={handleDetails}
            />
        ), [test])
    }


    const saveEvent = () => {
        setLoad(true)

        // console.log("bb=>", props.modalData.id);

        const postData = new FormData();
        postData.append('title', data.title)
        postData.append('date', data.date)
        postData.append('school', data.school)
        postData.append('cover', cover)
        postData.append('thumb', thumb)
        postData.append('details', details)
        postData.append('metaTitle', data.metaTitle)
        postData.append('keywords', data.keywords)
        postData.append('metaDesc', data.metaDesc)

        postData.append('author', data.author)
        postData.append('author_id', 'admin')
        postData.append('authorType', 'admin')
        postData.append('isApprove', 1)


        {
            props.studentId && 
            postData.append('studentId', props.studentId)
        }
        {
            props.modalData?.id &&
            postData.append('id', props.modalData?.id)
        }
        // for (const value of postData.values()) {
        //     console.log(value,'postData');
        //   }
        //   return;
        axios.post(`${process.env.REACT_APP_MAIN_API}saveBlog`, postData)
            .then((res) => {
                // console.log(res);
                // return;
                props.handleClose();
                setLoad(false)
                Swal.fire({
                    title: 'Success!',
                    text: 'Added Succeffully !',
                    icon: 'success',
                    confirmButtonText: 'Ok'
                })

            })
            .catch((err) => {
                // console.log(err);
                Swal.fire({
                    title: 'Error!',
                    text: 'Something went wrong !',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            })

    }

    React.useEffect(() => {
        setData({
            ...props.modalData,
            metaDesc: props.modalData?.metaDescription
        });
        // console.log(props.modalData, 'props.modalData');
        setDetails(props.modalData?.details)
        setTest(test + 1)
    }, [props])

    // console.log(props, 'props.modalData');

    return (
        <>
            <div className='row'>

                <div className='col-md-12 p-2'>
                    <label htmlFor="">Blog Title:</label>
                    <input type="text" className='form-control' name="title" value={data.title} onChange={handleInput} id="" />
                </div>

                <div className='col-md-4 p-2'>
                    <label htmlFor="">Author:</label>
                    <input type="text" className='form-control' name="author" value={data.author} onChange={handleInput} id="" />
                </div>
                <div className='col-md-4 p-2'>
                    <label htmlFor="">Date:</label>
                    <input type="date" className='form-control' name="date" value={data.date} onChange={handleInput} id="" />
                </div>

                <div className='col-md-4 p-2'>
                    <label htmlFor="">School:</label>
                    {/* <input type="text" className='form-control' name="school" value={data.school} onChange={handleInput} id="" /> */}

                    <select className='form-control' name='school' value={data.school} onChange={handleInput}>
                        <option>--selest--</option>
                        {schools && schools.map((sch) =>
                        (
                            <option value={sch.schoolName}>{sch.schoolName}</option>
                        ))}
                        <option value="All">All</option>
                    </select>

                </div>


                <div className='col-md-6 p-2'>
                    <label htmlFor="">Cover Image: </label>
                    <input type="file" className='form-control' name="cover" onChange={handleImg} id="" />
                    {
                        props.modalData?.cover &&
                        <img src={`${process.env.REACT_APP_BACKEND}blogs/cover/${props.modalData.cover}`} height={50}  />
                    }
                </div>
                <div className='col-md-6 p-2'>
                    <label htmlFor="">Thumbnails: </label>
                    <input type="file" className='form-control' name="thumb" onChange={handleImg} id="" />
                    {
                        props.modalData?.thumb &&
                        <img src={`${process.env.REACT_APP_BACKEND}blogs/thumb/${props.modalData.thumb}`} height={50} />
                    }
                </div>

                <div className='col-md-12 p-2'>
                    <label htmlFor="">Content:</label>
                    {Details()}
                </div>

                <div className='col-md-6 p-2'>
                    <label htmlFor="">Meta Title:</label>
                    <input type="text" className='form-control' name="metaTitle" value={data.metaTitle} onChange={handleInput} id="" />
                </div>
                <div className='col-md-6 p-2'>
                    <label htmlFor="">Keywords:</label>
                    <input type="text" className='form-control' name="keywords" value={data.keywords} onChange={handleInput} id="" />
                </div>
                <div className='col-md-12 p-2'>
                    <label htmlFor="">Meta Description:</label>
                    <input type="text" className='form-control' name="metaDesc" value={data.metaDesc} onChange={handleInput} id="" />
                </div>

                <div className='col-md-12 p-4 text-center'>
                    <Button variant='contained' disabled={load ? true : false} onClick={saveEvent}>Save Blog</Button>
                </div>



            </div>
        </>
    )
}

export default AddBlogForm;